import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class RegisterOptionCardBaseComponent extends BaseComponent {
  public text: string = "RegisterOptionCard";

  constructor(user: UserService) {
    super(user);
  }
}
